import { selector } from 'recoil'
import userAtom from '@/pages/User/user.atom.ts'

const selectAccessRightsSet = selector({
  key: 'self/access-rights/set',
  get: ({ get }) => {
    const { accessRights } = get(userAtom)

    if (!accessRights) {
      return new Set()
    }
    return new Set(accessRights.map((r) => r.id))
  },
})

const userSelectors = { selectAccessRightsSet }
export default userSelectors
